// removed by extract-text-webpack-plugin
module.exports = {"image-gallery":"XQCQhCYF8ahfkCVlQYbTv"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reportDetail/ReportDetailImageFieldTemplate.less
 ** module id = 851
 ** module chunks = 0
 **/